<template>
  <LKRoadmapsFeedModalContainer content-class="delete" @close="$emit('close')">
    <div class="text-sm-bold mod--delete">
      <span v-if="options.files.length > 1">
        Загрузка файлов:
        {{ currentIndex }} из {{ options.files.length }}
      </span>
      <span v-else>
        Загрузка файла...
      </span>
    </div>

    <div class="delete-attention__buttons">
      <LKProgressCircular />
    </div>
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import { RoadmapEventsApi } from '@/api/resources'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKRoadmapsFeedModalContainer from './LKRoadmapsFeedModalContainer.vue'

export default {
  name: 'LKRoadmapsFeedModalLoadFiles',
  components: {
    LKProgressCircular,
    LKRoadmapsFeedModalContainer,
  },
  props: {
    options: {
      type: Object,
    },
  },
  data: () => ({
    currentIndex: 0,
    isLoading: false,
  }),
  created() {
    this.onLoadFiles()
  },
  methods: {
    close(flag = false) {
      if (this.isLoading) return
      this.$emit('close', flag)
    },
    async onLoadFiles() {
      const api = new RoadmapEventsApi()
      const { files, node, event_id: eventId } = this.options

      this.isLoading = true

      const promise = files.reduce(
        (acc, file) => acc.then(() => {
          this.currentIndex += 1
          // eslint-disable-next-line promise/no-nesting
          return api
            .uploadFile(eventId, file)
            .then((apiResult) => {
              const { data: result } = apiResult
              const { id } = result
              const data = (
                node.children.map((child) => child.data) || []
              ).concat(
                files.map((raw_file) => ({
                  id,
                  name: raw_file.name,
                  raw_file: {
                    name: raw_file.name,
                    size: raw_file.size,
                  },
                })),
              )
              node.data.files = data
              node.setChildren(data, false, node.isActive)
              return true
            })
            .catch((e) => this.$notice.errors(e))
        }),
        Promise.resolve(),
      )

      await promise

      this.isLoading = false
      this.close(true)
    },
  },
}
</script>
